import { XIcon } from "lucide-react";

import { Column } from "@/components/Column";

import { cn } from "@/lib/utils";

export const ErrorPlaceholder = ({
  className,
  errorMessage,
}: {
  className?: string;
  errorMessage?: string;
}) => {
  return (
    <div className="px-6">
      <Column className="items-center justify-center rounded-md bg-red-50 p-6">
        <XIcon className={cn("size-10 text-red-500", className)} />
        <p className="text-red-900">
          Something went wrong{errorMessage && `: ${errorMessage}`}
        </p>
        <p className="text-red-900">Please let your local clacker know!</p>
      </Column>
    </div>
  );
};
